import React from 'react';
import { Box, styled } from '@mui/material';
import { PDFViewer } from '@react-pdf/renderer';

const StyledBox = styled(Box)(() => ({
    iframe: {
        width: '100%',
        height: '100vh',
    },
}));

export const PDFContainer: React.FC<{ children: React.ReactNode }> = (
    props
) => {
    return (
        <StyledBox>
            <PDFViewer>
                <>{props.children}</>
            </PDFViewer>
        </StyledBox>
    );
};
